import { useEffect, useRef } from 'react';
import { useUserData, useAuthenticationStatus } from '@nhost/react';
import { userRoles } from 'types/user';

export const ThirdPartyChatLoaders = () => {
  const crispLoadedRef = useRef(false);
  // const difyLoadedRef = useRef(false);

  const { isLoading } = useAuthenticationStatus(); // espera a que termine auth
  const user = useUserData();
  const isSuperAdmin = user?.defaultRole === userRoles.SHIPAID_ADMIN;

  useEffect(() => {
    if (isLoading) return;

    // ====== CRISP (solo NO admins) ======
    if (!isSuperAdmin && !crispLoadedRef.current) {
      const crispId = process.env.REACT_APP_CRISP_WEBSITE_ID || '';
      if (!crispId) {
        console.warn(
          '[ThirdPartyChatLoaders] Missing REACT_APP_CRISP_WEBSITE_ID',
        );
      } else if (!document.getElementById('crisp-sdk')) {
        (window as any).$crisp = [];
        (window as any).CRISP_WEBSITE_ID = crispId;

        const s = document.createElement('script');
        s.src = 'https://client.crisp.chat/l.js';
        s.async = true;
        s.id = 'crisp-sdk';
        document.head.appendChild(s);

        crispLoadedRef.current = true;
      }
    }

    // ====== DIFY (solo super admins) ======
    // if (isSuperAdmin && !difyLoadedRef.current) {
    //   const token: string = process.env.REACT_APP_DIFY_TOKEN || '';
    //   if (!token) {
    //     console.warn('[ThirdPartyChatLoaders] Missing DIFY_TOKEN');
    //   } else if (!document.getElementById('dify-sdk')) {
    //     (window as any).difyChatbotConfig = {
    //       token,
    //       baseUrl: 'https://dify.shipaid.com',
    //       containerProps: {
    //         style: {
    //           width: '50px',
    //           height: '50px',
    //           borderRadius: '30px',
    //         },
    //       },
    //     };

    //     const difyScript = document.createElement('script');
    //     difyScript.src = 'https://dify.shipaid.com/embed.min.js';
    //     difyScript.defer = true;
    //     difyScript.id = 'dify-sdk';
    //     document.head.appendChild(difyScript);

    //     if (!document.getElementById('dify-styles')) {
    //       const difyStyles = document.createElement('style');
    //       difyStyles.id = 'dify-styles';
    //       difyStyles.innerHTML = `
    //         #dify-chatbot-bubble-button { background-color: #1C64F2 !important; }
    //         #dify-chatbot-bubble-window { width: 30rem !important; height: 50rem !important; }
    //       `;
    //       document.head.appendChild(difyStyles);
    //     }

    //     difyLoadedRef.current = true;
    //   }
    // }
  }, [isLoading, isSuperAdmin]);

  return null;
};
